<form [formGroup]="form" class="example-form">
  <mat-form-field matLine appearance="fill">
    <mat-label>Replacement SKU</mat-label>
    <mat-select (selectionChange)="changeType()" formControlName="type">
      <mat-option *ngFor="let val of selectValues" [value]="val.value">
        {{val.viewValue}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <br>
  <mat-menu class="primary" #skuFilterObsolete="matMenu">
    <button [disabled]="currentFilter === 'Contains'" (click)="changeFilterType('Contains')" mat-menu-item>Contains</button>
    <button [disabled]="currentFilter === 'Equals'" (click)="changeFilterType('Equals')" mat-menu-item>Equals</button>
  </mat-menu>
  <div *ngIf="showSearch" style="position: relative;">
    <button [matMenuTriggerFor]="skuFilterObsolete" mat-icon-button class="sku-obsolete-filter-btn">
      <mat-icon>filter_list</mat-icon>
    </button>
    <mat-form-field *ngIf="showSearch" class="example-full-width" appearance="fill">
      <mat-label>SKU ({{currentFilter}})</mat-label>
      <input style="width: auto;" type="text" #skuSearch (input)="onChange($event)" matInput formControlName="sku" [matAutocomplete]="auto">

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let option of filteredOptions | async" data-id="option.id" [value]="option">
          {{option.sku}}
          <b>{{option.product_id}}</b>
        </mat-option>
      </mat-autocomplete>
      <b style="display: inline-block; margin-top: 5px;" *ngIf="replacementProduct">{{replacementProduct.product_id}}</b>
    </mat-form-field>
  </div>

  <br>
  <button style="width:100%;" (click)="save()" mat-raised-button color="warn">OK</button>
</form>
